export const PRODUCT_INDEXING_LIST_SUCCESS = 'PRODUCT_INDEXING_LIST_SUCCESS';
export const CREATE_PRODUCT_INDEXING_SUCCESS = 'CREATE_PRODUCT_INDEXING_SUCCESS';
export const EDIT_PRODUCT_INDEXING_SUCCESS = 'EDIT_PRODUCT_INDEXING_SUCCESS';
export const REMOVE_PRODUCT_INDEXING_SUCCESS = 'REMOVE_PRODUCT_INDEXING_SUCCESS';
